<script>
  import { mapGetters } from 'vuex';


  export default {
    name: 'CartMixin',

    data() {
      return {
        isNavigatingToOrderSummary: false
      };
    },

    computed: {
      ...mapGetters('locations', ['selectedLocation']),
      ...mapGetters('session', ['orderDetails']),
      ...mapGetters('menu', ['menu']),
      ...mapGetters('orders', ['order'])
    },

    methods: {
      openCartPage() {
        if (!this.selectedLocation.storeId) {
          this.$openModal('no-selected-location-modal');
        }
        else if (!this.selectedLocation.isReadyForOrdering) {
          this.$openModal('location-currently-closed-modal');
        }
        else if (this.order.orderItemCount === 0) {
          this.$openModal('empty-cart-modal');
        }
        else {
          this.goToOrderSummaryPage();
        }
      },

      async goToOrderSummaryPage() {
        this.isNavigatingToOrderSummary = true;
        // this.$nextTick(); was not working and updating dom, so using setTimeout fn intead.
        setTimeout(() => {
          this.$closeAllModals();

          this.$router.push({ name: 'orderAheadCheckoutSummaryPage', params: { merchantId: this.$route.params.merchantId } });
        }, 1000);
      }
    }
  };
</script>
